import { useContext } from 'react';

import BpkInput, {
  CLEAR_BUTTON_MODES,
} from '@skyscanner-internal/backpack-web/bpk-component-input';
import {
  BpkBox,
  BpkFlex,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';

import Separator from '../../Separator';
import StringsContext from '../Contexts/StringsContext';
import { BOARD_TYPE } from '../server/constants';

import STYLES from './FlightSearch.module.scss';

interface FlightSearchProps {
  clearSearchValue: () => void;
  freeTextSearch: string;
  selected: string;
  updateFreeTextSearchValue: (newValue: string) => void;
}

const FlightSearch = ({
  clearSearchValue,
  freeTextSearch,
  selected,
  updateFreeTextSearchValue,
}: FlightSearchProps) => {
  const strings = useContext(StringsContext);

  return (
    <BpkBox
      paddingTop={BpkSpacing.Base}
      paddingBottom={BpkSpacing.Base}
      data-testid="flight-search"
    >
      <BpkFlex>
        <BpkInput
          className={STYLES.FlightSearch__inputContainer}
          onChange={(e) => updateFreeTextSearchValue(e.target.value)}
          value={freeTextSearch}
          id="freeTextSearch"
          name="freeTextSearch"
          placeholder={
            selected === BOARD_TYPE.ARRIVALS
              ? strings.falcon_arrivals_departures_board_arrvsearchplaceholder
              : strings.falcon_arrivals_departures_board_deptsearchplaceholder
          }
          clearButtonMode={CLEAR_BUTTON_MODES.always}
          clearButtonLabel={strings.falcon_adb_clear_input}
          onClear={clearSearchValue}
          aria-label={strings.falcon_arrivals_departures_board_searchlabel}
          autoFocus
        />
      </BpkFlex>

      <Separator />
    </BpkBox>
  );
};

export default FlightSearch;
